module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("6GsoP"))).then(() => parcelRequire('p1UY9'));